import * as React from "react";
import type { SVGProps } from "react";
const SvgTwoDirectionalArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#2953FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.44}
      d="m9.2 6.8 2.4-2.4L9.2 2M3.2 4.398h8.4M6.8 9.2l-2.4 2.4L6.8 14M12.8 11.602H4.4"
    />
  </svg>
);
export default SvgTwoDirectionalArrow;
